import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Load_com = () => {
  const [displayText, setDisplayText] = useState('');
  const [currentFactIndex, setCurrentFactIndex] = useState(0);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const typingTimeout = useRef(null);
  const hasInitialized = useRef(false); // Prevent repeated requests
  const isDevelopment = process.env.NODE_ENV === 'development'; // Detect development mode

  // const { amazon_url, flipkart_url } = location.state?.requestBody || {};

  const facts = [
    "India's eCommerce market is expected to reach $200 billion by 2026.",
    "Around 70% of eCommerce transactions in India are made through mobile phones.",
    "India has over 900 million internet users, making it one of the largest markets for eCommerce.",
    "The number of online shoppers in India reached around 150 million in 2023.",
    "Fashion and apparel is the largest category in Indian eCommerce, followed by electronics and groceries.",
    "Digital payments, including UPI and wallets, are rapidly growing in India, making online shopping more accessible.",
    "Flipkart and Amazon dominate the Indian eCommerce market, followed by Myntra, Snapdeal, and BigBasket.",
    "Tier 2 and Tier 3 cities are increasingly adopting eCommerce, contributing to the market's growth.",
    "The Digital India initiative has boosted cashless transactions and increased online shopping adoption.",
    "By 2025, rural India is expected to contribute 30-35% of the total online shoppers in India.",
  ];

  const typeFact = (fact) => {
    let currentIndex = 0;
    const textLength = fact.length;
    const timePerChar = 100; // Time per character in ms

    const typeChar = () => {
      if (currentIndex <= textLength) {
        setDisplayText(fact.slice(0, currentIndex));
        currentIndex++;
        typingTimeout.current = setTimeout(typeChar, timePerChar);
      } else {
        // After typing, wait for 2 seconds and show the next fact
        setTimeout(() => {
          setCurrentFactIndex((prevIndex) => (prevIndex + 1) % facts.length);
        }, 2000);
      }
    };

    typeChar();
  };

  useEffect(() => {
    // Prevent unnecessary re-runs in development mode with React Strict Mode
    if (isDevelopment && hasInitialized.current) {
      return;
    }
    
    // Validate input before proceeding
    const request_url= location.state;
    if (!request_url || !request_url.url1 || !request_url.url2 || !request_url.spec) {
      setError('Invalid input received. Please check the provided data.');
      return;
    }
    console.log(request_url)
    
  
    // Mark as initialized
    hasInitialized.current = true;
  
    // Set up timeout for the entire request
    const maxWaitTime = 240000; // 240 seconds
    const timeoutId = setTimeout(() => {
      setError('Request timed out. Unable to fetch data within 240 seconds.');
      navigate('/compres');
      hasInitialized.current = false;
    }, maxWaitTime);
  
    const fetchData = async () => {
      try {
        const response = await fetch('https://rahulbro123-mayabazar.hf.space/compare_products', {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            // Consider adding any authentication headers if needed
          },
          body: JSON.stringify({
            url1: request_url.url1,
            url2: request_url.url2,
            spec: request_url.spec,
          }),
        });
  
        // Handle non-200 responses
        // if (!response.ok) {
        //   throw new Error(`HTTP error! status: ${response.status}`);
        // }
  
        const data = await response.json();
  
        // Check for specific response condition
        if (data !== 'Request ignored') {
          navigate('/compres', { 
            state: { 
              result: JSON.stringify(data) 
            } 
          });
        } else {
          // Handle 'Request ignored' scenario
          setError('Request was ignored by the server.');
        }
      } catch (err) {
        console.error('Error fetching data:', err);
        setError(`Failed to fetch data: ${err.message}`);
        navigate('/compare');
      } finally {
        // Ensure timeout is cleared even if an error occurs
        clearTimeout(timeoutId);
      }
    };
  
    // Initiate the fetch
    fetchData();
  
    // Cleanup function
    return () => {
      clearTimeout(timeoutId);
      clearTimeout(typingTimeout.current);
    };
  }, [location.state, navigate, facts, isDevelopment]);

   useEffect(() => {
      typeFact(facts[currentFactIndex]);
      return () => clearTimeout(typingTimeout.current); // Cleanup timeout on unmount
    }, [currentFactIndex]);


  const generateCubes = () => {
    const cubes = [];
    for (let h = 1; h <= 3; h++) {
      for (let w = 1; w <= 3; w++) {
        for (let l = 1; l <= 3; l++) {
          cubes.push({ h, w, l });
        }
      }
    }
    return cubes;
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-900">
      <div className="w-full max-w-lg p-8 text-center">
        <div className="relative h-64 mb-6">
          <div className="container">
            <style jsx>{`
              .container {
                position: relative;
                height: 100px;
                width: 86px;
                transform: scale(0.5);
                transform-origin: center center;
                margin: 100px auto;
              }

              .cube {
                position: absolute;
                width: 86px;
                height: 100px;
              }

              .face {
                height: 50px;
                width: 50px;
                position: absolute;
                transform-origin: 0 0;
              }

              .right {
                background: #E79C10;
                transform: rotate(-30deg) skewX(-30deg) translate(49px, 65px) scaleY(0.86);
              }

              .left {
                background: #D53A33;
                transform: rotate(90deg) skewX(-30deg) scaleY(0.86) translate(25px, -50px);
              }

              .top {
                background: #1d9099;
                transform: rotate(210deg) skew(-30deg) translate(-75px, -22px) scaleY(0.86);
                z-index: 2;
              }

              ${generateCubes().map(({ h, w, l }) => `
                .h${h}.w${w}.l${l} {
                  z-index: -${h};
                  animation: h${h}w${w}l${l} 3s ease infinite;
                }

                @keyframes h${h}w${w}l${l} {
                  0% {
                    transform: translate(${(w * -50 - 50) + (l * 50 + 50)}%, ${(h * 50 - 200) + (w * 25 - 25) + (l * 25 + 25)}%);
                  }
                  14% {
                    transform: translate(${(w * -50 - 50) + (l * 100 - 50)}%, ${(h * 50 - 200) + (w * 25 - 25) + (l * 50 - 25)}%);
                  }
                  28% {
                    transform: translate(${(w * -100 + 50) + (l * 100 - 50)}%, ${(h * 50 - 200) + (w * 50 - 75) + (l * 50 - 25)}%);
                  }
                  43% {
                    transform: translate(${(w * -100 - 100) + (l * 100 + 100)}%, ${(h * 100 - 400) + (w * 50 - 50) + (l * 50 + 50)}%);
                  }
                  57% {
                    transform: translate(${(w * -100 - 100) + (l * 50 + 200)}%, ${(h * 100 - 400) + (w * 50 - 50) + (l * 25 + 100)}%);
                  }
                  71% {
                    transform: translate(${(w * -50 - 200) + (l * 50 + 200)}%, ${(h * 100 - 375) + (w * 25 - 25) + (l * 25 + 100)}%);
                  }
                  85%, 100% {
                    transform: translate(${(w * -50 - 50) + (l * 50 + 50)}%, ${(h * 50 - 200) + (w * 25 - 25) + (l * 25 + 25)}%);
                  }
                }
              `).join('\n')}

              @keyframes blink {
                0%, 100% { opacity: 1; }
                50% { opacity: 0; }
              }

              .cursor {
                display: inline-block;
                width: 2px;
                height: 1em;
                background-color: white;
                margin-left: 2px;
                animation: blink 1s step-end infinite;
                vertical-align: middle;
              }
            `}</style>

            {generateCubes().map(({ h, w, l }, index) => (
              <div key={index} className={`cube h${h} w${w} l${l}`}>
                <div className="face top"></div>
                <div className="face left"></div>
                <div className="face right"></div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-lg shadow-lg p-6 transform transition-all hover:scale-105">
          <p className="text-base text-white/90 italic font-light leading-relaxed">
            {displayText}
            <span className="cursor"></span>
          </p>
          <p className="mt-3 text-sm text-white/60"></p>
        </div>

        {error && <div className="text-red-500">{error}</div>}
      </div>
    </div>
  );
};

export default Load_com;

